import { render, staticRenderFns } from "./GetMore.vue?vue&type=template&id=10312ac8&scoped=true&"
import script from "./GetMore.vue?vue&type=script&lang=js&"
export * from "./GetMore.vue?vue&type=script&lang=js&"
import style0 from "./GetMore.vue?vue&type=style&index=0&id=10312ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10312ac8",
  null
  
)

export default component.exports